import { IconProps } from "../../utils/global-types/global-types";

const CheckboxCheckedIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <g
        id="checkbox-checked-icon"
        fill="none"
        fillRule="evenodd"
        stroke="none"
        strokeWidth="1"
      >
        <g id="checkbox-checked-icon" fill="currentColor" fillRule="nonzero">
          <path
            id="checkbox-checked-icon"
            d="M18 3a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3zm-1.53 4.97L10 14.44l-2.47-2.47a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l7-7a.75.75 0 0 0-1.06-1.06"
          ></path>
        </g>
      </g>
    </svg>
  );
};

export default CheckboxCheckedIcon;
